import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Card, notification } from 'antd';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { addProductPackage, addProductPackageReset } from '../../redux/slice/productPackage/addProductPackageSlice';
import {
  updateProductPackage,
  updateProductPackageReset,
} from '../../redux/slice/productPackage/updateProductPackageSlice';
import CreateProductPackage from '../../organisms/CreateProductPackage';
import {
  getProductPackageById,
  getProductPackageByIdReset,
} from '../../redux/slice/productPackage/getProductPackageByIdSlice';
import PageInnerHeader from '../../molecules/PageInnerHeader';

const AddUpdateProductPackage = ({ afterCloseModal }) => {
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [editDetail, setEditDetail] = useState({});
  const [editForm, setEditForm] = useState(false);
  const { setHeaderData } = useOutletContext();

  const navigate = useNavigate();
  const { id } = useParams();

  const dispatch = useDispatch();
  const addProductPackageState = useSelector((state) => state.addProductPackageState);
  const updateProductPackageState = useSelector((state) => state.updateProductPackageState);
  const getProductPackageByIdState = useSelector((state) => state.getProductPackageByIdState);

  const handleUpdateSubmit = (data) => {
    setLoadingSubmit(true);
    dispatch(
      updateProductPackage({
        ...data,
        packageId: editDetail.packageId,
      }),
    );
  };

  const handleAddSubmit = (data) => {
    setLoadingSubmit(true);
    dispatch(
      addProductPackage({
        ...data,
      }),
    );
  };

  useEffect(() => {
    setHeaderData({ pageName: 'Product Package' });
    return () => {
      dispatch(getProductPackageByIdReset());
    };
  }, []);

  useEffect(() => {
    if (addProductPackageState.status === 'success') {
      notification.success({
        message: 'Success',
        description: addProductPackageState.message,
        duration: 3,
      });
      setLoadingSubmit(false);
      dispatch(addProductPackageReset());
      navigate('/schedule/product-package');
    } else if (addProductPackageState.status === 'error') {
      notification.error({
        message: 'Failed',
        description: addProductPackageState.message,
        duration: 3,
      });
      setLoadingSubmit(false);
      dispatch(addProductPackageReset());
    }
  }, [addProductPackageState]);

  useEffect(() => {
    if (updateProductPackageState.status === 'success') {
      notification.success({
        message: 'Success',
        description: updateProductPackageState.message,
        duration: 3,
      });
      setLoadingSubmit(false);
      dispatch(updateProductPackageReset());
      navigate('/schedule/product-package');
    } else if (updateProductPackageState.status === 'error') {
      notification.error({
        message: 'Failed',
        description: updateProductPackageState.message,
        duration: 3,
      });
      setLoadingSubmit(false);
      dispatch(updateProductPackageReset());
    }
  }, [updateProductPackageState]);

  useEffect(() => {
    if (id) {
      dispatch(getProductPackageById({ packageId: id }));
    }
  }, [id]);

  useEffect(() => {
    if (getProductPackageByIdState.status === 'success') {
      setEditDetail(getProductPackageByIdState.data);
      setEditForm(true);
    }
  }, [getProductPackageByIdState]);

  return (
    <>
      <PageInnerHeader
        title={editForm ? `Update Package` : `Create Package`}
        navigatePath='/schedule/product-package'
      />
      <Card>
        <CreateProductPackage
          handleAddSubmit={handleAddSubmit}
          handleUpdateSubmit={handleUpdateSubmit}
          afterCloseModal={afterCloseModal}
          editForm={editForm}
          editDetail={editDetail}
          loadingSubmit={loadingSubmit}
        />
      </Card>
    </>
  );
};
export default AddUpdateProductPackage;
